import { useState, useEffect, useCallback } from 'react';

interface Position {
	x: number;
	y: number;
}

export const useTextSelection = () => {
	const [selectedText, setSelectedText] = useState('');
	const [position, setPosition] = useState<Position>({ x: 0, y: 0 });
	const [isVisible, setIsVisible] = useState(false);

	const handleTextSelection = useCallback(() => {
		const selection = window.getSelection();
		const text = selection?.toString().trim();

		if (text && text.length > 0) {
			const range = selection?.getRangeAt(0);
			const rect = range?.getBoundingClientRect();

			if (rect) {
				setSelectedText(text);
				setPosition({
					x: rect.left + window.scrollX + rect.width / 2,
					y: rect.top + window.scrollY,
				});
				setIsVisible(true);
			}
		} else {
			setIsVisible(false);
		}
	}, []);

	useEffect(() => {
		document.addEventListener('mouseup', handleTextSelection);
		return () => {
			document.removeEventListener('mouseup', handleTextSelection);
		};
	}, [handleTextSelection]);

	const closePopup = useCallback(() => {
		setIsVisible(false);
		setSelectedText('');
	}, []);

	return {
		selectedText,
		position,
		isVisible,
		closePopup,
	};
};
